import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/EditMyCompanyMemberFinancialPaycheckGroupWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import * as _ from 'lodash';
import EditDataIcon from '../assets/images/edit-specification-code-64x64.svg';
import {
  readCompanyMember,
  updateCompanyMemberFinancialPaycheckData,
} from '../redux/actions/table/my_company_members';
import EditMyCompanyMemberFinancialPaycheckGroupForm from '../forms/edit_my_company_member_financial_paycheck_group_wizard/EditMyCompanyMemberFinancialPaycheckGroupForm';
import EditMyCompanyMemberFinancialPaycheckFutureGroupForm from '../forms/edit_my_company_member_financial_paycheck_group_wizard/EditMyCompanyMemberFinancialPaycheckFutureGroupForm';

@mapStateToProps((state) => ({
  store: _.get(state.table, 'my_company_members'),
}))
@withRouter
class EditMyCompanyMemberFinancialPaycheckGroupWizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: '01',
      steps: [
        {
          id: '01',
          title: __('wizard.my-company-members.title.paycheck-current-group'),
        },
        {
          id: '02',
          title: __('wizard.my-company-members.title.paycheck-future-group'),
        },
      ],
    };
  }
  @autobind
  _setActiveStep(id) {
    this.setState({ active: id });
  }
  @autobind
  _handleSubmitCurrent(formData) {
    const { store } = this.props;

    let data = {
      ...formData,
      user_id: store.flyout.details.id,
    };

    return validateForm(
      updateCompanyMemberFinancialPaycheckData(data).then(() => {
        //setNotification('Current financial paycheck group updated.');
        //setTableParams('my_company_members', {
        //  flyout: response.data,
        //});
        //this.props.onClose();

        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __('my-company-members.financial.current-paycheck-group.updated')
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  @autobind
  _handleSubmitFuture(formData) {
    const { store } = this.props;

    let data = {
      ...formData,
      user_id: store.flyout.details.id,
      is_new: true,
    };

    return validateForm(
      updateCompanyMemberFinancialPaycheckData(data).then(() => {
        // setNotification('Future financial paycheck group updated.');
        // setTableParams('my_company_members', {
        //   flyout: response.data,
        // });
        // this.props.onClose();

        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __('my-company-members.financial.future-paycheck-group.updated')
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  render() {
    const { financialPaycheckData } = this.props.store;
    const { steps, active } = this.state;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.title}>
            <div className={styles.left}>
              <span>
                {__(
                  'wizard.my-company-members.title.edit-my-company-member-financial-paycheck-group'
                )}
              </span>
              <span>
                {__(
                  'wizard.my-company-members.subtitle.edit-my-company-member-financial-paycheck-group'
                )}
              </span>
            </div>
            <div className={styles.right}>
              <EditDataIcon />
            </div>
          </div>
          <div className={styles.steps}>
            {_.map(steps, (step, i) => (
              <div
                key={i}
                onClick={() => this._setActiveStep(step.id)}
                className={`
                ${styles.step} 
                ${active === step.id ? styles.active : ''}
              `}
              >
                <span>{step.id}</span>
                <span>{step.title}</span>
              </div>
            ))}
          </div>{' '}
        </div>

        {/* TAB CONTENT */}
        <div className={styles.body}>
          {active === '01' && (
            <EditMyCompanyMemberFinancialPaycheckGroupForm
              onSubmit={this._handleSubmitCurrent}
              initialValues={{
                paycheck_currency_id:
                  financialPaycheckData?.current?.paycheck_currency_id || null,
                brutto_1: financialPaycheckData?.current?.brutto_1 || null,
                brutto_2: financialPaycheckData?.current?.brutto_2 || null,
                netto: financialPaycheckData?.current?.netto || null,
                paycheck_start_date:
                  financialPaycheckData?.current?.paycheck_start_date || null,
                paycheck_end_date:
                  financialPaycheckData?.current?.paycheck_end_date || null,
              }}
            />
          )}

          {active === '02' && (
            <EditMyCompanyMemberFinancialPaycheckFutureGroupForm
              onSubmit={this._handleSubmitFuture}
              initialValues={{
                // paycheck_currency_id:
                //   financialPaycheckData?.future?.paycheck_currency_id || null,
                paycheck_currency_id: financialPaycheckData?.future
                  ?.paycheck_currency_id
                  ? financialPaycheckData?.future?.paycheck_currency_id
                  : financialPaycheckData?.current?.paycheck_currency_id ||
                    null,
                brutto_1: financialPaycheckData?.future?.brutto_1 || null,
                brutto_2: financialPaycheckData?.future?.brutto_2 || null,
                netto: financialPaycheckData?.future?.netto || null,
                paycheck_start_date:
                  financialPaycheckData?.future?.paycheck_start_date || null,
                paycheck_end_date:
                  financialPaycheckData?.future?.paycheck_end_date || null,
              }}
            />
          )}
        </div>
      </>
    );
  }
}

export default EditMyCompanyMemberFinancialPaycheckGroupWizard;
